import Span from 'src/components/atomic/atom/Span'
import { useTranslation } from 'react-i18next'
import Div from 'src/components/atomic/atom/Div'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import Spinner from 'src/components/atomic/atom/Spinner'
import Svg from 'src/components/atomic/atom/Svg'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useBeforeUnload } from 'react-router-dom'
import { useCallback } from 'react'
import { setModalItems, setCloseModal } from 'src/store/Reducer/common/modalSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setExplorerFileDownCancelToggle } from 'src/store/Reducer/page/explorerPageSlice'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { SocketSender } from 'src/api/socket'
import Lottie from 'lottie-react'
import loadingLottie from 'src/assets/imgs/lottie/check.json'

const BackupDataModal = () => {
  const dispatch = useAppDispatch()

  const { text } = useAppSelector((state: RootState) => state.modal)
  const { t } = useTranslation()

  const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = ''
  }

  const BackupDataCancelHandler = () => {
    dispatch(SocketSender(Cmdtypes.EXPLORER_FILE_DOWNLOAD_CANCEL))
    dispatch(
      setModalItems({
        type: 'alert',
        text: t('EXPLORER.FILE.DOWNLOAD.CANCEL', {
          defaultValue: 'Data backup has been interrupted at user request.',
        }) as string,
      }),
    )
    dispatch(setExplorerFileDownCancelToggle(true))
  }

  useBeforeUnload(useCallback((e) => text === 'loading...' && handleBeforeUnload(e), [text]))

  return (
    <>
      {text === 'loading...' ? (
        <>
          <Span option={'medium_bold'}>
            {t('MODAL.BACK_UP.TITLE', { defaultValue: 'Back up Data' })}
          </Span>
          <Div
            $padding={'16px'}
            $bgColor={COLOR.black2}
            $border_radius={'12px'}
            $margin={'16px auto'}
          >
            <Div height={'24px'} $margin={'0 0 10px 0'}>
              <Spinner $height={'unset'} />
            </Div>
            <Span option={'tiny'}>{text}</Span>
          </Div>
          <Div display={'flex'} $margin={'0 0 16px 0'} $justify_content={'center'} $gap={'8px'}>
            <Svg name={'notice_icon'} width={'20'} height={'20'} color={COLOR.brand} />
            <Span option={'tiny'} width={'unset'} $text_align={'left'}>
              {t('MODAL.BACK_UP.INFORMATION')}
            </Span>
          </Div>
          <Button
            option={'modal_cancel'}
            $margin={'0'}
            onClick={BackupDataCancelHandler}
            $border={`1px solid ${COLOR.brand};`}
          >
            <Span color={COLOR.brand} option={'small_bold'}>
              {t('BUTTON.CANCEL', { defaultValue: 'Cancel' })}
            </Span>
          </Button>
        </>
      ) : (
        <>
          <Span option={'medium_bold'}>
            {t('MODAL.BACK_UP.TITLE', { defaultValue: 'Back up Data' })}
          </Span>
          <Div $margin={'16px auto 0 auto'}>
            <Span option={'tiny'}>{text}</Span>
            <Lottie animationData={loadingLottie} style={{ width: '100px', margin: '16px auto' }} />
            {/*<Image $ImgSrc={GreenCheckImg} width={'100px'} $margin={'16px auto'} />*/}
            <Button
              option={'modal_ok'}
              $margin={'0'}
              onClick={() => dispatch(setCloseModal())}
              $bgColor={COLOR.brand}
            >
              <Span color={COLOR.white} option={'small_bold'}>
                {t('BUTTON.OK', { defaultValue: 'OK' })}
              </Span>
            </Button>
          </Div>
        </>
      )}
    </>
  )
}

export default BackupDataModal
